import React from 'react';
import { Helmet } from 'react-helmet';

export const Refinance = () => (
  <Helmet>
    <title>Own Up | Refinancing - Get the best deal on your mortgage</title>
    <meta
      name="description"
      content="Own Up uses better technology to shop a network of lenders that enables the average homeowner to save on a refinance."
    />
  </Helmet>
);

export const Purchase = () => (
  <Helmet>
    <title>Own Up | Buying - Get the best deal on your mortgage</title>
    <meta
      name="description"
      content="Own Up uses better technology to shop a network of lenders that enables the average homeowner to save on a home purchase."
    />
  </Helmet>
);



// WEBPACK FOOTER //
// ./src/components/meta.js